(() => {
  const pageSelector = '.jdgm-write-review-modal__page--share-media';
  const titleSelector = '.jdgm-write-review-modal__title';
  const introSelector = '.jdgm-write-review-modal__intro';
  const title = 'Share Your Special Moment';
  const intro = 'Share up to 5 photos and 1 video with your review.';

  const updateMediaStepCopy = (root = document) => {
    root.querySelectorAll(pageSelector).forEach((page) => {
      const titleElement = page.querySelector(titleSelector);
      const introElement = page.querySelector(introSelector);

      if (titleElement && titleElement.textContent.trim() !== title) {
        titleElement.textContent = title;
      }

      if (introElement && introElement.textContent.trim() !== intro) {
        introElement.textContent = intro;
      }
    });
  };

  const start = () => {
    updateMediaStepCopy();

    new MutationObserver((mutations) => {
      if (mutations.some(({ addedNodes }) => addedNodes.length > 0)) {
        updateMediaStepCopy();
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
